import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { DynamicHeadline } from "../../DynamicHeadline"
import Image from "../../Image"
import { TeaserLink } from "../TeaserLinksItem"
import styles from "./TeaserLinksFancyGridItem.module.scss"
import LinkButton from "components/ui/LinkButton"
import useWindowWidth from "hooks/window-width"
import Shape from "components/ui/Shape"

const TeaserLinksFancyGridItem = ({
  teaser,
  itemBgColor,
  className,
  content,
}) => {
  const windowWidth = useWindowWidth()
  const {
    link_link: link,
    link_image: image,
    link_text: text,
    link_anchor: anchor,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    new_tab: newTab,
    full_width,
    mobile_image,
  } = teaser

  const teaserLinkWrapperCN = cn(styles.teaserLinkWrapper, className, {
    [styles.fullWidth]: full_width,
    [styles.normal]: !full_width,
    [styles[`teaserLinkWrapper--${content.locale}`]]: content.locale,
  })

  const isMobile = windowWidth < 768

  let imageUrl = image?.permalink
  let imageAlt = image?.alt
  let imageFocusCss = image?.focus_css

  if (isMobile && mobile_image) {
    imageUrl = mobile_image?.permalink
    imageAlt = mobile_image?.alt
    imageFocusCss = mobile_image?.focus_css
  }

  return (
    <TeaserLink className={teaserLinkWrapperCN}>
      <div className={styles.inner}>
        <div
          className={styles.bg}
          style={{ backgroundColor: itemBgColor }}
          aria-hidden={!image}
        >
          <Shape type="corner-round" className={styles.letterImage} />
          {imageUrl && (
            <div className={styles.imageWrapper}>
              <Image
                src={imageUrl}
                alt={imageAlt}
                className={styles.image}
                quality={100}
                style={{ objectPosition: imageFocusCss }}
                sizes={full_width ? "100vw" : "60vw"}
                fill
              />
            </div>
          )}
        </div>
        <div className={styles.content}>
          {headline && (
            <DynamicHeadline
              className={styles.headline}
              headlineType={headlineType.value}
              headlineAppearance={headlineAppearance.value}
            >
              {headline}
            </DynamicHeadline>
          )}
          {text && (
            <div className={styles.text}>
              <RenderBardWithComponents content={text} prefix="link_text_" />
            </div>
          )}
          <LinkButton
            data={{
              link_url: link,
              link_text: "Ansehen",
              link_blank: newTab,
              link_anchor: anchor,
              show_arrow: true,
            }}
          />
        </div>
      </div>
    </TeaserLink>
  )
}

export default TeaserLinksFancyGridItem
